<template>
  <div :class="rootClass">
    <b-row style="color: black">
      <b-tabs style="width: 100%">
        <b-tab title="Tra cứu mã giới thiệu" @click="changeTab(1)">
          <b-col cols="12">
            <b-row class="mb-2">
              <b-col lg="3" sm="12">
                <b-row align-v="center">
                  <label :class="rootClass + '__phone-number-label'"
                  >Số thuê bao:</label
                  >
                  <b-form-input
                      ref="inputSearchPhone"
                      v-model="searchPhone"
                      :class="rootClass + '__phone-number-input'"
                      v-on:keyup.enter="getMGMCode"
                  ></b-form-input>
                  <b-button
                      :class="rootClass + '__search-voice-sms-data-btn'"
                      class="redButton ml-2"
                      variant="danger"
                      @click="getMGMCode()"
                  >Tra cứu
                  </b-button>
                </b-row>
              </b-col>
              <!--              <b-col sm="12" lg="3" style="display: flex; align-items: center;">-->
              <!--                <b-row align-v="center">-->
              <!--                  <div style="color: black" class="d-flex align-items-center">-->
              <!--                    Mã giới thiệu:-->
              <!--                    <b-form-input-->
              <!--                      ref="MGMCode"-->
              <!--                      :value="mgmCode"-->
              <!--                      readonly-->
              <!--                      class="removeFocus w-50 bg-white ml-1"-->
              <!--                    ></b-form-input>-->
              <!--                  </div>-->
              <!--                  <button-->
              <!--                    @click="copyCode"-->
              <!--                    class="btn text-white redButton"-->
              <!--                    style="margin-left: -5%;"-->
              <!--                    :class="rootClass + '__search-voice-sms-data-btn'"-->
              <!--                  >-->
              <!--                    Copy-->
              <!--                  </button>-->
              <!--                </b-row>-->
              <!--              </b-col>-->
              <b-col lg="3" sm="12" style="display: flex; align-items: center;">
                <b-row align-v="center">
                  <div class="d-flex align-items-center" style="color: black">
                    Link giới thiệu:
                    <b-form-input
                        ref="MGMLink"
                        :value="mgmLink"
                        class="removeFocus w-50 bg-white ml-1"
                        readonly
                    ></b-form-input>
                  </div>
                  <button
                      :class="rootClass + '__search-voice-sms-data-btn'"
                      class="btn text-white redButton"
                      style="margin-left: -5%;"
                      @click="copyLink"
                  >
                    Copy
                  </button>
                </b-row>
              </b-col>
              <b-col lg="3" sm="12" style="display: flex; align-items: center;">
                <div class="d-flex w-100 ">
                  <div class="d-flex align-items-center" style="color: black">
                    Tổng số bản ghi:
                    <b-form-input
                        :value="totalRecords"
                        class=" removeFocus w-25 bg-white ml-1"
                        readonly
                    ></b-form-input>
                  </div>
                </div>
              </b-col>
              <b-col
                  lg="12"
                  sm="12"
                  style="display: flex; justify-content: end"
              >
                <b-button
                    :class="rootClass + '__export-voice-sms-data-btn'"
                    class="redButton"
                    variant="danger"
                    @click="exportExcelMGMCode"
                ><span>
                    <feather-icon class="mr-50" icon="SaveIcon" size="16"
                    /></span>
                  Xuất file
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <table :class="rootClass + '__history-voice-sms-data-table'">
                <tr style="height: 3rem;position: sticky">
                  <template v-for="(h, i) in historyMGMTable.fields">
                    <th
                        :key="h.key"
                        :class="{
                        '--first-th': i === 0,
                        '--last-th': i === historyMGMTable.fields.length - 1
                      }"
                        style="min-width: 80px"
                    >
                      {{ h.label }}
                    </th>
                  </template>
                </tr>
                <template v-for="(r, index) in mgmHis">
                  <tr :key="index" style="color:black;">
                    <td>{{ index + 1 }}</td>
                    <td>{{ r.name }}</td>
                    <td>{{ r.type }}</td>
                    <td class="text-left pl-2" v-html="r.description"></td>
                    <td>{{ r.start_date }}</td>
                    <td>{{ r.end_date }}</td>
                    <td>{{ statusList[r.status] }}</td>
                  </tr>
                </template>
              </table>
            </b-row>
          </b-col>
        </b-tab>
        <b-tab title="Tra cứu KQ sử dụng MGT" @click="changeTab(2)">
          <b-col cols="12">
            <b-row class="mb-2">
              <b-col lg="3" sm="12">
                <b-row align-v="center">
                  <label :class="rootClass + '__phone-number-label'"
                  >Số thuê bao</label
                  >
                  <b-form-input
                      ref="inputSearchPhone"
                      v-model="searchPhone"
                      :class="rootClass + '__phone-number-input'"
                      v-on:keyup.enter="getNumberUseMGM"
                  ></b-form-input>
                </b-row>
              </b-col>
              <b-col
                  lg="3"
                  sm="12"
                  style="display: flex; align-items: baseline "
              >
                <p>Số lượng TB giới thiệu thành công:</p>
                <b-form-input
                    :value="mgmUseHisExtra.total"
                    class=" removeFocus w-25 bg-white ml-2"
                    readonly
                ></b-form-input>
              </b-col>
              <b-col
                  lg="3"
                  sm="12"
                  style="display: flex; align-items: baseline "
              >
                <p>Số lượng TB đã kích hoạt:</p>
                <b-form-input
                    :value="mgmUseHisExtra.number_active"
                    class=" removeFocus w-25 bg-white ml-2"
                    readonly
                ></b-form-input>
              </b-col>
              <b-col lg="3" sm="12" style="display: flex; justify-content: end">
                <b-button
                    :class="rootClass + '__export-voice-sms-data-btn'"
                    class="redButton"
                    variant="danger"
                    @click="exportExcelNumberUseMGM"
                ><span>
                    <feather-icon class="mr-50" icon="SaveIcon" size="16"
                    /></span>
                  Xuất file
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <table :class="rootClass + '__history-voice-sms-data-table'">
                <tr style="height: 3rem; border-bottom: 1px solid #ececec">
                  <template v-for="(h, i) in historyUseTable.fields">
                    <th
                        :key="i"
                        :class="{
                        '--first-th': i === 0,
                        '--last-th': i === historyUseTable.fields.length - 1
                      }"
                    >
                      {{ h.label }}
                    </th>
                  </template>
                </tr>
                <tr v-for="(ele, i) in mgmUseHis" :key="ele.id">
                  <td>{{ i + 1 }}</td>
                  <td>{{ ele.date }}</td>
                  <td>{{ ele.Msisdn }}</td>
                  <td>{{ ele.Active }}</td>
                  <td>{{ ele.chanel }}</td>
                </tr>
              </table>
            </b-row>
          </b-col>
        </b-tab>
        <b-tab title="Tra cứu hoa hồng" @click="changeTab(3)">
          <b-col cols="12">
            <b-row class="mb-2">
              <b-col lg="3" sm="12">
                <b-row align-v="center">
                  <label :class="rootClass + '__phone-number-label'"
                  >Số thuê bao</label
                  >
                  <b-form-input
                      ref="inputSearchPhone"
                      v-model="searchPhone"
                      :class="rootClass + '__phone-number-input'"
                      v-on:keyup.enter="getTopupMGT"
                  ></b-form-input>
                </b-row>
              </b-col>
              <b-col
                  lg="3"
                  sm="12"
                  style="display: flex; align-items: baseline "
              >
                <p>Số lượng ưu đãi đã nhận:</p>
                <b-form-input
                    :value="totalRecords"
                    class=" removeFocus w-25 bg-white ml-2"
                    readonly
                ></b-form-input>
              </b-col>
              <b-col lg="6" sm="12" style="display: flex; justify-content: end">
                <b-button
                    :class="rootClass + '__export-voice-sms-data-btn'"
                    class="redButton"
                    variant="danger"
                    @click="exportExcelTopUp"
                ><span>
                    <feather-icon class="mr-50" icon="SaveIcon" size="16"
                    /></span>
                  Xuất file
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <table :class="rootClass + '__history-voice-sms-data-table'">
                <tr style="height: 3rem; border-bottom: 1px solid #ececec">
                  <template v-for="(h, i) in topupTable.fields">
                    <th
                        :key="i"
                        :class="{
                        '--first-th': i === 0,
                        '--last-th': i === topupTable.fields.length - 1
                      }"
                    >
                      {{ h.label }}
                    </th>
                  </template>
                </tr>
                <tr v-for="(ele, i) in topupHis" :key="ele.id">
                  <td>{{ i + 1 }}</td>
                  <td>{{ ele.phone }}</td>
                  <td>{{ ele.topup_value }}</td>
                  <td>{{ ele.topup_time }}</td>
                  <td>{{ ele.chanel }}</td>
                  <td>{{ ele.status }}</td>
                </tr>
              </table>
            </b-row>
            <b-row
                v-if="showErrSearchSpam"
                style="justify-content: center;font-size: 18px"
            >
              Không tìm thấy kết quả!
            </b-row>
          </b-col>
        </b-tab>
        <div class="d-flex justify-content-end">
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRecords"
              per-page="20"
          ></b-pagination>
        </div>
      </b-tabs>
    </b-row>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BImg,
  BInputGroup,
  BInputGroupPrepend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip
} from "bootstrap-vue";
import vSelect from "vue-select";
import DropMenu from "./DropMenu.vue";
import useJwt from "@/auth/jwt/useJwt";
import moment from "moment/moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BModal,
    BFormGroup,
    BFormCheckbox,
    BImg,
    BButtonGroup,
    BInputGroup,
    BInputGroupPrepend,
    BTabs,
    BTab,
    BContainer,
    BFormDatepicker,
    DropMenu
  },
  data() {
    return {
      currentTab: 1,
      currentPage: 1,
      totalRecords: 0,
      rootClass: "search-crs",
      fromDate: new Date(),
      toDate: new Date(),
      historyMGMTable: {
        fields: [
          {key: "stt", label: "STT"},
          {key: "name", label: "Tên chương trình"},
          {key: "type", label: "Tệp áp dụng"},
          {key: "discount", label: "Nội dung khuyến mãi"},
          {key: "start_date", label: "Thời gian bắt đầu"},
          {key: "end_date", label: "Thời gian kết thúc"},
          {key: "status", label: "Trạng thái"}
        ]
      },
      historyUseTable: {
        fields: [
          {key: "stt", label: "STT"},
          {key: "active_date", label: "Thời gian sử dụng MGT"},
          {key: "Msisdn", label: "Số thuê bao được giới thiệu"},
          {key: "Active", label: "Thời gian kích hoạt"},
          {key: "chanel", label: "Kênh áp dụng"}
        ]
      },
      topupTable: {
        fields: [
          {key: "stt", label: "STT"},
          {key: "Msisdn", label: "Số thuê bao được giới thiệu"},
          {key: "topup_value", label: "Hoa hồng đã nhận"},
          {key: "topup_time", label: "Thời gian nhận"},
          {key: "chanel", label: "Hình thức chi trả"},
          {key: "status", label: "Trạng thái"}
        ]
      },
      mgmHis: [],
      topupHis: [],
      mgmUseHis: [],
      mgmUseHisExtra: {},
      regex087: /87\d{7}$/,
      showErrSearch: false,
      showErrSearchSpam: false,
      totalDuration: 0,
      totalDataUse: 0,
      totalTransactionAmount: 0,
      mgmCode: "",
      statusList: {
        "0": "Chưa diễn ra",
        "1": "Đang diễn ra",
        "2": "Đã kết thúc"
      }
    };
  },
  props: {
    searchPhone: String
  },
  watch: {
    currentPage(val) {
      if (this.currentTab === 1) {
        this.getMGMCode();
      }
      if (this.currentTab === 2) {
        this.getNumberUseMGM();
      }
      if (this.currentTab === 3) {
        this.getTopupMGT();
      }
    }
  },
  mounted() {
    this.$root.$on("bv::dropdown::show", bvEvent => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = true;
      }
    });
    this.$root.$on("bv::dropdown::hide", bvEvent => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = false;
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault();
      }
    });
    this.getMGMCode();
  },
  computed: {
    mgmLink() {
      let phone = this.searchPhone;
      if (this.searchPhone.startsWith("84")) {
        phone = phone.replace("84", "0");
      }
      // if ($ctx.API_URL.includes("dev")) {
      //   return "https://gioithieu.itel.dev/" + phone;
      // } else {
      //   return "https://gioithieu.itel.vn/" + phone;
      // }
      return "https://gioithieu.itel.vn/" + phone;
    }
  },
  methods: {
    changeTab(tab) {
      this.currentPage = 1;
      this.currentTab = tab;
      if (tab === 1) {
        this.getMGMCode();
      }
      if (tab === 2) {
        this.getNumberUseMGM();
      }
      if (tab === 3) {
        this.getTopupMGT();
      }
    },
    copyCode() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Copy code thành công!",
          icon: "CheckSquareIcon",
          variant: "success"
        }
      });
      navigator.clipboard.writeText(this.$refs.MGMCode.value);
    },
    copyLink() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Copy link thành công!",
          icon: "CheckSquareIcon",
          variant: "success"
        }
      });
      navigator.clipboard.writeText(this.$refs.MGMLink.value);
    },
    formatPhoneNum() {
      if (this.searchPhone.startsWith("0")) {
        this.searchPhone = this.searchPhone.substring(1);
        this.searchPhone = 84 + this.searchPhone;
      }
    },
    getMGMCode() {
      this.showLoading("block");
      this.formatPhoneNum();
      useJwt
          .post("get-MGT/" + this.searchPhone, {
            page: this.currentPage,
            pageSize: 20
          })
          .then(response => {
            this.showLoading("none");
            this.mgmCode = response.data.result.code;
            this.mgmHis = response.data.result.list;
            this.mgmHis.forEach((item, index) => {
              item.start_date = moment(item.start_date).format("DD/MM/YYYY");
              item.end_date = moment(item.end_date).format("DD/MM/YYYY");
            });
            this.totalRecords = response.data.totalRecords;
          })
          .catch(error => {
            this.showLoading("none");
            console.log(error);
          });
    },
    // commit
    getNumberUseMGM() {
      this.showLoading("block");
      this.formatPhoneNum();
      useJwt
          .post("get-number-use-MGT/" + this.searchPhone, {
            page: this.currentPage,
            pageSize: 20
          })
          .then(response => {
            this.showLoading("none");
            this.mgmUseHis = response.data.result;
            this.mgmUseHisExtra = response.data.extra;
            this.mgmUseHis.forEach((item, index) => {
              item.chanel = "Web iTel";
              item.date = moment(item.date).format("DD/MM/YYYY HH:mm:ss");
            });
            this.totalRecords = response.data.totalRecords;
          })
          .catch(error => {
            this.showLoading("none");
            console.log(error);
          });
    },
    getTopupMGT() {
      this.showLoading("block");
      this.formatPhoneNum();
      useJwt
          .post("get-topup-MGT/" + this.searchPhone, {
            page: this.currentPage,
            pageSize: 20
          })
          .then(response => {
            this.topupHis = response.data.result;
            this.topupHis.forEach((item, index) => {
              item.topup_time = moment(item.topup_time).format(
                  "DD/MM/YYYY HH:mm:ss"
              );
              item.topup_value = item.topup_value.toLocaleString("it-IT", {
                style: "currency",
                currency: "VND"
              });
            });
            this.totalRecords = response.data.totalRecords;
            this.showLoading("none");
          })
          .catch(error => {
            this.showLoading("none");
            console.log(error);
          });
    },
    exportExcelMGMCode() {
      this.showLoading("block");
      this.formatPhoneNum();
      useJwt
          .post(
              "export-MGTS",
              {
                columnFilters: {
                  phone: this.searchPhone
                }
              },
              {responseType: "blob"}
          )
          .then(response => {
            this.showLoading("none");
            var fileURL = window.URL.createObjectURL(
                new Blob([response.data], {
                  type: "application/vnd.ms-excel"
                })
            );
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute(
                "download",
                "Mã giới thiệu " + this.searchPhone + ".xlsx"
            );
            document.body.appendChild(fileLink);
            fileLink.click();
          })
          .catch(error => {
            this.showLoading("none");
            error.response.data.text().then(res => {
              const message = JSON.parse(res).message;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: "AlertTriangleIcon",
                  variant: "danger"
                }
              });
            });
          });
    },
    exportExcelTopUp() {
      this.showLoading("block");
      this.formatPhoneNum();
      useJwt
          .post(
              "export-topup-MGT",
              {
                columnFilters: {
                  phone: this.searchPhone
                }
              },
              {responseType: "blob"}
          )
          .then(response => {
            this.showLoading("none");
            var fileURL = window.URL.createObjectURL(
                new Blob([response.data], {
                  type: "application/vnd.ms-excel"
                })
            );
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute(
                "download",
                "Hoa hồng " + this.searchPhone + ".xlsx"
            );
            document.body.appendChild(fileLink);
            fileLink.click();
          })
          .catch(error => {
            this.showLoading("none");
            error.response.data.text().then(res => {
              const message = JSON.parse(res).message;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: "AlertTriangleIcon",
                  variant: "danger"
                }
              });
            });
          });
    },
    exportExcelNumberUseMGM() {
      this.showLoading("block");
      this.formatPhoneNum();
      useJwt
          .post(
              "export-number-use-MGT",
              {
                columnFilters: {
                  phone: this.searchPhone
                }
              },
              {responseType: "blob"}
          )
          .then(response => {
            this.showLoading("none");
            var fileURL = window.URL.createObjectURL(
                new Blob([response.data], {
                  type: "application/vnd.ms-excel"
                })
            );
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute(
                "download",
                "Lịch sử dùng mã giới thiệu " + this.searchPhone + ".xlsx"
            );
            document.body.appendChild(fileLink);
            fileLink.click();
          })
          .catch(error => {
            this.showLoading("none");
            error.response.data.text().then(res => {
              const message = JSON.parse(res).message;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: "AlertTriangleIcon",
                  variant: "danger"
                }
              });
            });
          });
    },
    showLoading(options) {
      document.getElementById("loading-bg").style.display = options;
    },

    checkDate(fromDate, toDate) {
      fromDate = moment(this.fromDate);
      toDate = moment(this.toDate);
      return fromDate.diff(toDate, "days");
    }
  }
};
</script>

<style lang="scss" scoped>
.removeFocus:focus {
  outline: none;
}

.search-crs {
  position: relative;
  font-size: 16px;
  font-family: "Times New Roman";
  min-height: 500px;

  &__card {
    border-radius: 2rem;
    background: #fcfcfc;
  }

  &__func-group-btns {
    border: 1px solid red;
    border-radius: 40px;
    height: 38px;
  }

  &__subscriber-information-btn {
    border-radius: 40px;
    font-weight: 800;
    color: #707070 !important;
    background: transparent !important;
    border: transparent;
    padding: 0.2rem 1.5rem;
  }

  &__search-crs-btn {
    border-radius: 40px !important;
    color: white;
    width: 195px;
    padding: 0.2rem 1.5rem;
  }

  &__phone-number-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 80px;
  }

  &__phone-number-input {
    font-weight: 500;
    color: black;
    font-size: 14px;
    width: 200px;
  }

  &__from-date-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 70px;
  }

  &__from-date-input {
    width: 200px;
  }

  &__to-date-label {
    font-weight: 500;
    color: black;
    font-size: 14px;
    margin-right: 0.3rem;
    width: 70px;
  }

  &__to-date-input {
    width: 200px;
  }

  &__search-voice-sms-data-btn {
    border-radius: 40px;
    //font-size: 10px;
  }

  &__history-voice-sms-data-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border: 0.299185px solid rgba(184, 184, 184, 0.5);
    }

    th {
      background-color: #ed1f24;
      color: white;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }

  &__export-voice-sms-data-btn {
    border-radius: 40px;
  }

  &__search-spam-btn {
    border-radius: 40px;
    font-size: 10px;
  }

  &__history-spam-table {
    background: white;
    border-radius: 16px;
    width: 100%;
    text-align: center;

    tr {
      height: 30px;
    }

    tr th,
    tr td {
      border-right: 0.299185px solid rgba(184, 184, 184, 0.5);
      border-left: 0.299185px solid rgba(184, 184, 184, 0.5);
    }

    tr td {
      color: black;
    }

    .--first-th {
      border-radius: 12px 0px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--last-th {
      border-radius: 0px 12px 0px 0px;
      border-right: unset;
      border-left: unset;
    }

    .--first-td {
      border-right: unset;
      border-left: unset;
    }

    .--last-td {
      border-right: unset;
      border-left: unset;
    }
  }

  &__menu-right-group {
    position: absolute;
    top: 60px;
    right: 20px;
  }
}

.redButton {
  background-color: #ed1f24 !important;
  border-color: #ed1f24 !important;
}

@media screen and (max-width: 576px) {
  .search-crs {
    &__phone-number-label {
      width: 100%;
    }

    &__phone-number-input {
      width: 100%;
    }

    &__from-date-label {
      width: 100%;
    }

    &__from-date-input {
      width: 100%;
    }

    &__to-date-label {
      width: 100%;
    }

    &__to-date-input {
      width: 100%;
    }
  }
}
</style>
